export default __webpack_public_path__ + "static/media/undone.413c9425.svg";